import React from 'react';
import { ChevronRight } from 'lucide-react';

/**
 * LearnMoreBanner — one full-width course banner under the shortcuts row.
 *
 * Deliberately a single large image rather than a carousel of small cards: this
 * slot exists to give one course enough room to be read at a glance while
 * scrolling past. `item` is a real learn-hub item, so the banner can never
 * advertise a course that does not exist.
 */
export default function LearnMoreBanner({ item, onOpen, onSeeAll }) {
  if (!item) return null;

  const image = item.heroImage || item.image;

  return (
    <div className="px-4 pt-5 desktop-shell" data-testid="learn-more">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-base md:text-lg font-bold text-[#0F172A]">Learn More</h2>
        <button
          type="button"
          data-testid="learn-more-see-all"
          onClick={onSeeAll}
          aria-label="See all courses"
          className="h-6 w-6 rounded-full bg-muted flex items-center justify-center text-muted-foreground hover:text-foreground"
        >
          <ChevronRight className="h-4 w-4" />
        </button>
      </div>

      <button
        type="button"
        data-testid="learn-more-banner"
        onClick={() => onOpen?.(item)}
        className="w-full text-left group"
      >
        <span className="relative block rounded-2xl overflow-hidden h-[190px] md:h-[300px]">
          <img
            src={image}
            alt=""
            className="absolute inset-0 h-full w-full object-cover transition-transform duration-300 group-hover:scale-[1.02]"
          />
          <span
            className="absolute inset-0"
            style={{ background: 'linear-gradient(to top, rgba(15,76,74,0.92) 0%, rgba(15,76,74,0.35) 45%, rgba(15,76,74,0.05) 100%)' }}
          />
          <span className="absolute inset-x-0 bottom-0 p-4 md:p-6">
            {item.tag && (
              <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold text-white ${item.tagColor || 'bg-primary'}`}>
                {item.tag}
              </span>
            )}
            <span className="block text-xl md:text-3xl font-extrabold text-white leading-tight mt-2">
              {item.title}
            </span>
            {item.date && (
              <span className="block text-xs md:text-sm text-white/80 mt-1">
                {item.date}
                {item.time ? ` · ${item.time}` : ''}
              </span>
            )}
          </span>
        </span>

        <span className="block text-sm md:text-base font-bold text-[#0F172A] mt-3 leading-snug">
          Get certified in Muslim funeral rites
        </span>
        <span className="block text-xs text-muted-foreground mt-0.5">
          {item.org}
          {item.location ? ` · ${item.location}` : ''}
        </span>
      </button>
    </div>
  );
}
